import type { CustomIconProps } from './FDIcon';

const VIEWBOX_WIDTH = 56;
const VIEWBOX_HEIGHT = 26;
const RATIO = VIEWBOX_WIDTH / VIEWBOX_HEIGHT;
const DEFAULT_HEIGHT = VIEWBOX_HEIGHT;

const PokerIcon = ({ width, height, size }: CustomIconProps) => {
  const base = size ?? height ?? width ?? DEFAULT_HEIGHT;
  const h =
    typeof base === 'number' ? base : parseFloat(base) || DEFAULT_HEIGHT;
  const w = h * RATIO;

  return (
    <svg
      className="poker"
      width={w}
      height={h}
      style={{ width: `${w}px`, height: `${h}px` }}
      viewBox="0 0 56 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#poker-logo-clip)">
        <path
          d="M36.3828 9.6674C38.038 8.89002 39.7939 8.42934 41.5066 8.2278C41.6937 8.19901 41.7657 8.32857 41.7513 8.47253C41.5354 9.79696 41.3915 11.1358 41.3339 12.489C41.3339 12.6474 41.2332 12.7481 41.0604 12.7769C40.1105 12.9641 39.175 13.252 38.1531 13.7271C39.0743 15.325 40.1969 16.7934 41.4203 18.0315C41.5642 18.1754 41.6505 18.3338 41.6793 18.5785C41.996 20.6371 42.5573 22.7102 43.3057 24.6824C43.3489 24.7976 43.3489 24.8696 43.2913 24.9271C43.2193 24.9847 43.1186 24.9847 43.0035 24.9271C35.5625 20.3924 31.0864 12.2731 31 3.75065C31 3.5491 31.072 3.39075 31.2447 3.28997C35.1883 1.07299 39.6356 0.00768946 44.0973 0.108461C44.2988 0.108461 44.3708 0.281214 44.2844 0.453965C43.6655 1.73521 43.1618 3.03085 42.7588 4.32649C42.7156 4.48484 42.6149 4.55682 42.4565 4.57122C40.0674 4.70078 37.7501 5.23343 35.62 6.11159C35.7784 7.32085 36.0374 8.50132 36.3828 9.653V9.6674ZM44.6154 4.58561C44.4715 4.58561 44.3708 4.44165 44.4139 4.29769C44.8889 2.94447 45.4214 1.64883 46.0259 0.468361C46.0979 0.324401 46.213 0.266817 46.3857 0.295609C49.7392 0.669905 52.92 1.73521 55.7553 3.31877C55.928 3.41954 56 3.5635 56 3.77944C55.9424 11.8412 51.8981 19.5718 45.1048 24.2361C44.9752 24.3225 44.8169 24.2793 44.745 24.121C44.2556 22.7965 43.8526 21.4433 43.5648 20.1477C43.5216 19.9749 43.5648 19.8454 43.6943 19.7446C47.8106 16.5055 50.6891 11.6684 51.3944 6.15478C49.293 5.29102 47.0334 4.74397 44.6154 4.6288V4.58561Z"
          fill="white"
        />
        <path
          opacity="0.25"
          d="M27 2.53613H26V22.5361H27V2.53613Z"
          fill="white"
        />
        <path
          d="M16.3734 5.30431C13.0959 2.02605 11 0 11 0C11 0 8.90409 2.04012 5.6266 5.30431C3.89642 7.03489 0 11.3262 0 15.5893C0 18.4314 2.30691 20.7389 5.14834 20.7389C7.01918 20.7389 8.6509 19.7399 9.55115 18.2485C9.63555 18.1359 9.79028 18.0515 9.95908 18.0515C10.2263 18.0515 10.4655 18.2344 10.4373 18.4736C10.2404 20.0072 9.36829 23.792 5.96419 25.0723H16.0217C12.6176 23.792 11.7596 20.0072 11.5627 18.4736C11.5345 18.2485 11.7737 18.0515 12.0409 18.0515C12.2097 18.0515 12.3504 18.1359 12.4488 18.2485C13.3491 19.7399 14.9808 20.7248 16.8517 20.7248C19.6931 20.7248 22 18.4173 22 15.5752C22 11.3121 18.1036 7.00675 16.3734 5.29024V5.30431ZM13.2506 12.2688L14.6432 16.5742L10.9859 13.915L7.32864 16.5742L8.72123 12.2688L5.06394 9.60966H9.59335L10.9859 5.30431L12.3785 9.60966H16.8939L13.2366 12.2688H13.2506Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="poker-logo-clip">
          <rect width="56" height="25.0723" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PokerIcon;
